import React from "react";
import BaseComponent from "../pages/base/BaseComponent";
import {Button, Card} from "@themesberg/react-bootstrap";
import PropTypes from 'prop-types';
import {isResponseOk} from "enqc-utilities/src/utils/Utilities";
import ImageCropper from "./ImageCropper";
import Endpoint from "enqc-utilities/src/api/Endpoint";
import axios from "axios";
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import StatusAttribute from "enqc-utilities/src/model/StatusAttribute";

export default class UserCard extends BaseComponent{
    constructor(props) {
        super(props);
        this.state = {
            user:this.props.user?this.props.user:{},
            imageCropper:false,
            imageBlob:undefined,
            imageUrl:undefined,
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props!=prevProps){
            let user = this.props.user?this.props.user:{}
            this.setState({user})
        }
    }

    async updatePhoto(){
        let {user} = this.state
        let {onRefresh} = this.props
        let multipartFile = await new Promise(resolve => {
            axios({
                url: user.photoUrl,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                this.closeProgress()
                var file = response.data ;
                resolve(file)
            })
        })

        let form = new FormData()
        form.append("userId", user.id)
        form.append("multipartFile", multipartFile)
        this.post(Endpoint.API.USER_UPLOAD_IMAGE, form, null, (res)=>{
            if(isResponseOk(res)){
                let userResponse = res.data
                user.photoUrl = userResponse.photoUrl
                if(onRefresh){
                    onRefresh(user)
                }
                this.setState({user})
            }
        }, true, true)
    }

    render() {
        let {user, imageCropper, imageUrl, imageBlob} = this.state
        let {hideControl} = this.props
        let userStatus = user.userStatus?user.userStatus:'ACTIVE'

        return (
            <Card border="light" className="text-center p-0 mb-4">
                <div className="profile-cover rounded-top bg-cyan" />
                <Card.Body className="pb-5">
                    <Card.Img src={user.photoUrl?user.photoUrl:ApplicationIcons.Icons.userAvatar} alt={user.fullname}
                              className="bg-white border-secondary user-avatar large-avatar rounded-circle mx-auto mt-n7 mb-4" />
                    <Card.Title>{user.fullname}</Card.Title>
                    <Card.Subtitle className="fw-normal">{user.userCode}</Card.Subtitle>
                    <Card.Text className="text-gray">{user.username}</Card.Text>
                    {
                        !hideControl?(
                            <>
                                <Card.Text className="text-gray mb-4">{user.roleInformation}</Card.Text>
                                <Button variant={"outline-"+StatusAttribute.UserStatus[userStatus.toUpperCase()].clazz} size="sm">
                                    <img width="24px" src={StatusAttribute.UserStatus[userStatus.toUpperCase()].icon}className="me-1" />{user.userStatus}
                                </Button>
                            </>
                        ):null
                    }
                 </Card.Body>
                <ImageCropper
                    src={imageUrl?imageUrl:""}
                    show={imageCropper?imageCropper:false}
                    callback={(imageUrl) => {
                        user.photoUrl = imageUrl
                        this.setState({imageUrl:undefined, user, imageCropper:false},async () => {
                            await this.updatePhoto()
                        })
                    }}
                    cancelCallback={() => {
                        this.setState({imageCropper:false,imageUrl:undefined})
                    }}/>
                {super.render()}
            </Card>
        );
    }

}
UserCard.propTypes = {
    user : PropTypes.any.isRequired,
    onRefresh: PropTypes.func.isRequired,
    hideControl:PropTypes.bool
}